import { render, staticRenderFns } from "./MultiColumnsBlockList.vue?vue&type=template&id=11a63594"
import script from "./MultiColumnsBlockList.vue?vue&type=script&lang=ts"
export * from "./MultiColumnsBlockList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports